import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Familiares } from '../../../../models/familiares';
import { FamiliaresService } from '../../../../services/familiares.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-familiares-list',
  templateUrl: './familiares-list.component.html',
  styleUrls: ['./familiares-list.component.css']
})
export class FamiliaresListComponent implements OnInit {

  @Input() personalId: number;
  @Input() familiares: Familiares[];
  @Input() permisoEdicion: boolean = true;
  @Input() fechaslist;
  @Output() VisualizarDetalle = new EventEmitter<Familiares>();

  familiaresOri: Familiares[];
  familiaresGrupo: Familiares[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private familiaresService: FamiliaresService,
              private momentService: MomentSetService) {

   }

  ngOnInit(): void 
  {
    this.familiaresOri = this.familiares;
    this.inicializaFiltros();
    
    this.filtrarFamiliares();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarFamiliares()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.familiares = this.familiaresOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.familiaresGrupo == undefined)
      {
        this.familiaresService.getFamiliares(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
              currentValue.fechaNacimiento = this.momentService.convertDateServer(currentValue.fechaNacimiento);
              currentValue.presentacionCertificado = this.momentService.convertDateServer(currentValue.presentacionCertificado);
            });
            
            this.familiaresGrupo = data;
            this.familiares = this.familiaresGrupo;
          });

      } else
      {
        this.familiares = this.familiaresGrupo;
      }
      
    } else
    {
      this.filtrarFamiliares();
    }
  }

  onChangeFiltros()
  {
    this.filtrarFamiliares();
  }

  visualizarDetalle(familiar)
  {
    this.VisualizarDetalle.emit(familiar);
  }

  add()
  {
    let fdesde = new Date().toString();
    let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    if (fecha != undefined){
      fdesde = fecha.desde
    } 
    let familiar: Familiares = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), apellido: '', email: '', nombre: '', contactoEmergencia: false, discapacitado: false, claseFamilia: 0, claseDocumento: 0, docNro: '', sexo: 0, segundoApellido: '', fechaNacimiento: new Date().toString(), celular: '', estadoCivil: 0, pais: 0, nacionalidad: 0 };
    this.VisualizarDetalle.emit(familiar);
  }
}
